<template>
    <div class="tw-flex tw-flex-col tw-gap-5 md:tw-gap-6">
        <!-- Destaque -->
        <section :class="card" class="tw-relative tw-overflow-hidden tw-p-6 md:tw-p-10 tw-flex tw-flex-col lg:tw-flex-row tw-gap-6 lg:tw-gap-8 lg:tw-items-center">
            <div class="tw-absolute -tw-right-32 -tw-top-40 tw-w-[520px] tw-h-[520px] tw-rounded-full tw-pointer-events-none" :style="{ background: 'radial-gradient(circle, rgba(34,197,94,.22), rgba(34,197,94,0) 65%)' }"></div>
            <div class="tw-relative tw-flex-1 tw-min-w-0 tw-flex tw-flex-col tw-gap-4">
                <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
                    <span class="tw-inline-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-full tw-bg-green-500/15 tw-text-green-400 tw-text-xs tw-font-bold tw-tracking-[0.12em]">
                        <svg class="tw-w-3.5 tw-h-3.5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.6 6.4L21 11l-6.4 2.6L12 20l-2.6-6.4L3 11l6.4-2.6z"/></svg>
                        WINCKIEEL IA
                    </span>
                    <button type="button" @click="abrirTutorial" class="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-semibold tw-transition"
                        :class="dark ? 'tw-bg-white/5 tw-text-gray-300 hover:tw-bg-white/10' : 'tw-bg-gray-100 tw-text-gray-700 hover:tw-bg-gray-200'">
                        <svg class="tw-w-3.5 tw-h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M10 9l5 3-5 3z"/></svg>
                        Como funciona
                    </button>
                </div>
                <h1 class="tw-text-2xl sm:tw-text-3xl md:tw-text-4xl tw-font-black tw-leading-tight tw-tracking-tight tw-max-w-2xl">
                    Saiba em segundos como está o seu grão e o que fazer agora.
                </h1>
                <p class="tw-text-sm md:tw-text-base tw-leading-relaxed tw-max-w-2xl" :class="soft">
                    A IA cruza a termometria de cada sensor, a tendência dos últimos 7 dias, o clima da estação e o programa de aeração do silo, e devolve um plano de ação.
                </p>
            </div>
            <div class="tw-relative tw-grid tw-grid-cols-3 tw-gap-3 lg:tw-w-[400px] tw-flex-shrink-0">
                <div v-for="n in numeros" :key="n.label" class="tw-rounded-2xl tw-p-4" :class="dark ? 'tw-bg-black/25' : 'tw-bg-gray-100'">
                    <p class="tw-font-mono tw-text-2xl md:tw-text-3xl tw-font-bold" :class="n.cor">{{ n.valor }}</p>
                    <p class="tw-text-xs md:tw-text-[13px] tw-mt-1" :class="muted">{{ n.label }}</p>
                </div>
            </div>
        </section>

        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-5 md:tw-gap-6 tw-items-start">
            <div class="tw-flex-1 tw-min-w-0 tw-w-full tw-flex tw-flex-col tw-gap-5 md:tw-gap-6">
                <!-- 1. Silo -->
                <section data-tour="silo" :class="card" class="tw-p-5 md:tw-p-7">
                    <div class="tw-flex tw-items-center tw-gap-3">
                        <span class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-green-500 tw-text-green-950 tw-text-sm tw-font-black tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">1</span>
                        <h2 class="tw-text-lg tw-font-bold">Escolha o silo</h2>
                    </div>
                    <p class="tw-text-sm tw-mt-1 tw-ml-10" :class="muted">A cor mostra o resultado da última análise de cada silo.</p>

                    <div v-if="carregando" class="tw-mt-5 tw-text-sm" :class="muted">Carregando silos...</div>
                    <div v-else ref="gradeSilos" class="tw-grid tw-gap-3 tw-mt-5" style="grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))">
                        <button v-for="s in silosVisiveis" :key="s.id" type="button" @click="$emit('selecionar', s.silo)" :aria-pressed="s.selecionado"
                            class="tw-relative tw-flex tw-gap-4 tw-items-center tw-p-4 tw-rounded-2xl tw-text-left tw-transition"
                            :class="s.selecionado ? 'tw-bg-green-500/10 tw-ring-2 tw-ring-green-500' : [dark ? 'tw-bg-[#15171a] tw-ring-1 tw-ring-[#262a30] hover:tw-ring-gray-600' : 'tw-bg-gray-50 tw-ring-1 tw-ring-gray-200 hover:tw-ring-gray-400']">
                            <div class="tw-w-16 tw-h-16 tw-flex-shrink-0 tw-flex tw-items-end tw-justify-center">
                                <div class="tw-relative" :class="[s.armazem ? 'tw-w-16 tw-h-11' : 'tw-w-12 tw-h-16', dark ? 'tw-bg-[#2a2f36]' : 'tw-bg-gray-200']" :style="{ clipPath: s.armazem ? 'polygon(0 40%, 50% 0, 100% 40%, 100% 100%, 0 100%)' : 'polygon(50% 0, 100% 24%, 100% 100%, 0 100%, 0 24%)' }">
                                    <div class="tw-absolute tw-inset-x-0 tw-bottom-0 tw-opacity-90" :style="{ height: `${s.nivel}%`, background: s.cor }"></div>
                                </div>
                            </div>
                            <div class="tw-flex tw-flex-col tw-gap-1 tw-min-w-0">
                                <span class="tw-text-[15px] tw-font-bold tw-truncate">{{ s.silo.nome }}</span>
                                <span class="tw-text-[13px] tw-truncate" :class="muted">{{ s.silo.produto || 'Sem produto' }} · {{ s.nivelTexto }}</span>
                                <span v-if="s.media" class="tw-font-mono tw-text-lg tw-font-bold">{{ s.media }} °C</span>
                                <span class="tw-self-start tw-mt-0.5 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-wide" :class="s.chip.classe">{{ s.chip.texto }}</span>
                            </div>
                            <span v-if="s.selecionado" class="tw-absolute tw-top-2.5 tw-right-2.5 tw-w-5 tw-h-5 tw-rounded-full tw-bg-green-500 tw-flex tw-items-center tw-justify-center">
                                <svg class="tw-w-3 tw-h-3" viewBox="0 0 24 24" fill="none" stroke="#052e16" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>
                            </span>
                        </button>
                    </div>
                    <div v-if="!carregando && silosOcultos > 0 || (expandido && silosView.length > limiteSilos)" class="tw-flex tw-justify-center tw-mt-4">
                        <button type="button" @click="expandido = !expandido" :aria-expanded="expandido"
                            class="tw-inline-flex tw-items-center tw-gap-2 tw-min-h-[40px] tw-px-4 tw-rounded-xl tw-text-sm tw-font-semibold tw-transition"
                            :class="dark ? 'tw-bg-white/5 tw-text-gray-200 hover:tw-bg-white/10' : 'tw-bg-gray-100 tw-text-gray-700 hover:tw-bg-gray-200'">
                            {{ expandido ? 'Mostrar menos' : `Mostrar todos os ${silosView.length} silos` }}
                            <svg class="tw-w-4 tw-h-4 tw-transition-transform" :class="{ 'tw-rotate-180': expandido }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
                        </button>
                    </div>
                </section>

                <!-- 2. Objetivo -->
                <section data-tour="objetivo" :class="card" class="tw-p-5 md:tw-p-7">
                    <div class="tw-flex tw-items-center tw-gap-3">
                        <span class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-green-500 tw-text-green-950 tw-text-sm tw-font-black tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">2</span>
                        <h2 class="tw-text-lg tw-font-bold">Qual o objetivo agora?</h2>
                    </div>
                    <p class="tw-text-sm tw-mt-1 tw-ml-10" :class="muted">As faixas de aeração recomendadas mudam conforme o objetivo.</p>
                    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-3 tw-mt-5">
                        <button v-for="o in objetivos" :key="o.id" type="button" @click="$emit('update:objetivo', o.id)" :aria-pressed="objetivo === o.id"
                            class="tw-flex tw-flex-col tw-items-start tw-gap-2.5 tw-p-5 tw-rounded-2xl tw-text-left tw-transition"
                            :class="objetivo === o.id ? [o.ring, dark ? 'tw-bg-white/[0.04]' : 'tw-bg-gray-50'] : [dark ? 'tw-bg-[#15171a] tw-ring-1 tw-ring-[#262a30] hover:tw-ring-gray-600' : 'tw-bg-gray-50 tw-ring-1 tw-ring-gray-200 hover:tw-ring-gray-400']">
                            <span class="tw-w-12 tw-h-12 tw-rounded-xl tw-flex tw-items-center tw-justify-center" :class="o.icone">
                                <svg class="tw-w-6 tw-h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path :d="o.path"/></svg>
                            </span>
                            <span class="tw-text-base tw-font-bold">{{ o.titulo }}</span>
                            <span class="tw-text-sm tw-leading-relaxed" :class="muted">{{ o.desc }}</span>
                            <span class="tw-text-[13px] tw-font-medium" :class="o.texto">{{ o.foco }}</span>
                        </button>
                    </div>
                </section>

                <!-- 3. Umidade -->
                <section data-tour="umidade" :class="card" class="tw-p-5 md:tw-p-7">
                    <div class="tw-flex tw-items-center tw-gap-3">
                        <span class="tw-w-7 tw-h-7 tw-rounded-full tw-bg-green-500 tw-text-green-950 tw-text-sm tw-font-black tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">3</span>
                        <h2 class="tw-text-lg tw-font-bold">Umidade do grão</h2>
                    </div>
                    <p class="tw-text-sm tw-mt-1 tw-ml-10" :class="muted">Opcional, mas sem ela os riscos de fungos e de reumedecimento ficam sem avaliação.</p>
                    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-mt-5 tw-ml-10">
                        <label for="ia-ug" class="tw-sr-only">Umidade do grão em porcentagem</label>
                        <div class="tw-flex tw-items-stretch tw-rounded-xl tw-overflow-hidden" :class="dark ? 'tw-bg-[#111316] tw-ring-1 tw-ring-[#2d3239]' : 'tw-bg-white tw-ring-1 tw-ring-gray-300'">
                            <input id="ia-ug" type="number" step="0.1" min="5" max="40" placeholder="13,5"
                                :value="umidade" @input="$emit('update:umidade', $event.target.value)"
                                class="tw-w-32 tw-px-4 tw-py-3 tw-bg-transparent tw-font-mono tw-text-2xl tw-font-bold tw-outline-none" />
                            <span class="tw-flex tw-items-center tw-px-4 tw-text-lg" :class="dark ? 'tw-bg-[#1f2226] tw-text-gray-400' : 'tw-bg-gray-100 tw-text-gray-500'">%</span>
                        </div>
                        <p v-if="ultimaUg" class="tw-text-sm" :class="soft">Última informada: <strong class="tw-font-mono">{{ ultimaUg.ug }}%</strong> em {{ ultimaUg.data }}</p>
                    </div>
                </section>
            </div>

            <!-- Resumo + ação -->
            <aside data-tour="gerar" :class="card" class="tw-w-full lg:tw-w-[360px] tw-flex-shrink-0 tw-p-6 md:tw-p-7 tw-flex tw-flex-col tw-gap-6 tw-ring-1 tw-ring-green-500/35">
                <div>
                    <p class="tw-text-xs tw-font-bold tw-tracking-[0.12em]" :class="muted">SUA ANÁLISE</p>
                    <p class="tw-text-2xl tw-font-black tw-mt-2">{{ selecionado ? selecionado.nome : 'Selecione um silo' }}</p>
                    <p v-if="selecionado" class="tw-text-[15px] tw-mt-1" :class="soft">
                        {{ selecionado.produto || 'Sem produto' }} · objetivo <strong class="tw-text-green-400">{{ objetivoAtual.titulo.toLowerCase() }}</strong>
                    </p>
                </div>
                <div class="tw-flex tw-flex-col tw-gap-4">
                    <p class="tw-text-xs tw-font-bold tw-tracking-[0.12em]" :class="muted">A IA VAI CRUZAR</p>
                    <div v-for="f in fontes" :key="f.titulo" class="tw-flex tw-gap-3.5 tw-items-center">
                        <span class="tw-w-10 tw-h-10 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" :class="[f.cor, dark ? 'tw-bg-white/5' : 'tw-bg-gray-100']">
                            <svg class="tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path :d="f.path"/></svg>
                        </span>
                        <div>
                            <p class="tw-text-[15px] tw-font-medium">{{ f.titulo }}</p>
                            <p class="tw-text-[13px]" :class="muted">{{ f.desc }}</p>
                        </div>
                    </div>
                </div>
                <button type="button" @click="gerar" :disabled="!selecionado"
                    class="tw-flex tw-items-center tw-justify-center tw-gap-2.5 tw-min-h-[56px] tw-rounded-xl tw-bg-green-600 hover:tw-bg-green-500 tw-text-white tw-text-[17px] tw-font-bold tw-shadow-[0_10px_30px_-8px_rgba(34,197,94,.6)] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed disabled:tw-shadow-none tw-transition">
                    <svg class="tw-w-5 tw-h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.6 6.4L21 11l-6.4 2.6L12 20l-2.6-6.4L3 11l6.4-2.6z"/></svg>
                    Gerar análise
                </button>
                <p class="-tw-mt-3 tw-text-[13px] tw-text-center" :class="muted">Usa a última leitura de termometria do silo</p>
            </aside>
        </div>
        <TutorialWinckieelIA :aberto="tutorialAberto" :theme="theme" @fechar="fecharTutorial" />
    </div>
</template>

<script>
import TutorialWinckieelIA from './TutorialWinckieelIA.vue';
import { ordenarPorNome } from '@/utils/ordenacao';

const CHAVE_TUTORIAL = 'winckieelIaTutorialVisto';

const STATUS = {
    seguro: { texto: 'Seguro', classe: 'tw-bg-green-500/15 tw-text-green-400', cor: '#22c55e' },
    atencao: { texto: 'Atenção', classe: 'tw-bg-yellow-500/15 tw-text-yellow-500', cor: '#facc15' },
    acao: { texto: 'Ação necessária', classe: 'tw-bg-orange-500/20 tw-text-orange-400', cor: '#f97316' },
};

const OBJETIVOS = [
    {
        id: 'secagem', titulo: 'Secagem', desc: 'Remover umidade do grão até a umidade segura de armazenagem.', foco: 'Prioriza ar seco, com UR baixa',
        icone: 'tw-bg-orange-500/15 tw-text-orange-400', texto: 'tw-text-orange-400', ring: 'tw-ring-2 tw-ring-orange-400',
        path: 'M12 2.7C9 6.5 6 9.8 6 13.5a6 6 0 0 0 12 0c0-3.7-3-7-6-10.8zM9 15l6-6',
    },
    {
        id: 'conservação', titulo: 'Conservação', desc: 'Manter a qualidade estável, sem aquecer nem reumedecer.', foco: 'Prioriza ar mais frio que a massa',
        icone: 'tw-bg-green-500/15 tw-text-green-400', texto: 'tw-text-green-400', ring: 'tw-ring-2 tw-ring-green-400',
        path: 'M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6zM9 12l2 2 4-4',
    },
    {
        id: 'resfriamento', titulo: 'Resfriamento', desc: 'Baixar a temperatura de toda a massa de grãos.', foco: 'Prioriza ar bem frio, de madrugada',
        icone: 'tw-bg-blue-500/15 tw-text-blue-400', texto: 'tw-text-blue-400', ring: 'tw-ring-2 tw-ring-blue-400',
        path: 'M2 12h20M12 2v20M20 16l-4-4 4-4M4 8l4 4-4 4M16 4l-4 4-4-4M8 20l4-4 4 4',
    },
];

export default {
    name: 'NovaAnaliseIA',
    props: {
        silos: { type: Array, default: () => [] },
        selecionadoId: { type: [Number, String], default: null },
        objetivo: { type: String, default: 'conservação' },
        umidade: { type: [Number, String], default: '' },
        ultimaUg: { type: Object, default: null },
        carregando: { type: Boolean, default: false },
        theme: { type: String, default: 'dark' },
    },
    components: { TutorialWinckieelIA },
    emits: ['selecionar', 'update:objetivo', 'update:umidade', 'gerar'],
    data() {
        return { tutorialAberto: false, expandido: false, colunasSilos: 4 };
    },
    watch: {
        carregando: {
            immediate: true,
            handler(valor) {
                if (valor || this.tutorialVisto()) return;
                this.$nextTick(() => setTimeout(this.abrirTutorial, 400));
            },
        },
    },
    computed: {
        dark() { return this.theme === 'dark'; },
        card() { return this.dark ? 'tw-bg-[#1a1d21] tw-text-gray-100 tw-rounded-2xl tw-shadow-2xl' : 'tw-bg-white tw-text-gray-800 tw-rounded-2xl tw-shadow'; },
        muted() { return this.dark ? 'tw-text-gray-400' : 'tw-text-gray-500'; },
        soft() { return this.dark ? 'tw-text-gray-300' : 'tw-text-gray-700'; },
        objetivos() { return OBJETIVOS; },
        objetivoAtual() { return OBJETIVOS.find(o => o.id === this.objetivo) || OBJETIVOS[1]; },
        selecionado() {
            return this.silos.find(s => String(s.id) === String(this.selecionadoId)) || null;
        },
        silosOrdenados() {
            return ordenarPorNome(this.silos);
        },
        limiteSilos() {
            return Math.max(1, this.colunasSilos) * 2;
        },
        silosVisiveis() {
            if (this.expandido || this.silosView.length <= this.limiteSilos) return this.silosView;
            const visiveis = this.silosView.slice(0, this.limiteSilos);
            const selecionado = this.silosView.find(s => s.selecionado);
            if (selecionado && !visiveis.includes(selecionado)) visiveis[visiveis.length - 1] = selecionado;
            return visiveis;
        },
        silosOcultos() {
            return this.expandido ? 0 : Math.max(0, this.silosView.length - this.limiteSilos);
        },
        silosView() {
            return this.silosOrdenados.map(s => {
                const status = s.ultima_analise && STATUS[s.ultima_analise.status_relatorio];
                const nivel = Math.max(0, Math.min(100, Number(s.nivel) || 0));
                return {
                    id: s.id,
                    silo: s,
                    selecionado: String(s.id) === String(this.selecionadoId),
                    armazem: s.tipo === 'armazem',
                    nivel,
                    nivelTexto: `${Math.round(nivel)}% de nível`,
                    media: s.media_atual != null ? this.fmt(s.media_atual) : null,
                    cor: status ? status.cor : '#6b7280',
                    chip: status
                        ? { texto: status.texto, classe: status.classe }
                        : { texto: s.ultima_analise ? 'Analisado' : 'Sem análise', classe: this.dark ? 'tw-bg-white/5 tw-text-gray-400' : 'tw-bg-gray-100 tw-text-gray-500' },
                };
            });
        },
        numeros() {
            const sensores = this.silos.reduce((t, s) => t + (Number(s.sensores) || 0), 0);
            const atencao = this.silos.filter(s => s.ultima_analise && ['atencao', 'acao'].includes(s.ultima_analise.status_relatorio)).length;
            const plural = (n, um, varios) => (n === 1 ? um : varios);
            return [
                { label: plural(this.silos.length, 'silo', 'silos'), valor: this.silos.length, cor: '' },
                { label: plural(sensores, 'sensor', 'sensores'), valor: sensores, cor: '' },
                { label: plural(atencao, 'silo necessita atenção', 'silos necessitam atenção'), valor: atencao, cor: atencao ? 'tw-text-yellow-400' : 'tw-text-green-400' },
            ];
        },
        fontes() {
            const s = this.selecionado;
            return [
                {
                    titulo: s && s.sensores ? `${s.sensores} sensores em ${s.cabos} cabos` : 'Termometria completa',
                    desc: 'Temperatura de cada ponto da massa', cor: 'tw-text-red-400',
                    path: 'M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z',
                },
                { titulo: 'Tendência de 7 dias', desc: 'Onde a massa está aquecendo', cor: 'tw-text-yellow-400', path: 'M3 17l6-6 4 4 8-8M15 7h6v6' },
                { titulo: 'Clima da estação', desc: 'Temperatura e umidade da última semana', cor: 'tw-text-blue-400', path: 'M17.5 19a4.5 4.5 0 1 0-1.4-8.8A6 6 0 0 0 4.3 12 4 4 0 0 0 6 19z' },
                { titulo: 'Programa de aeração', desc: 'Faixas atuais dos motores', cor: 'tw-text-green-400', path: 'M9.6 4.6A2 2 0 1 1 11 8H2M12.6 19.4A2 2 0 1 0 14 16H2M17.5 8a2.5 2.5 0 1 1 2 4H2' },
            ];
        },
    },
    mounted() {
        this.observarGrade();
    },
    updated() {
        this.observarGrade();
    },
    beforeUnmount() {
        if (this.observadorGrade) this.observadorGrade.disconnect();
        cancelAnimationFrame(this.quadroGrade);
    },
    methods: {
        observarGrade() {
            const el = this.$refs.gradeSilos;
            if (!el || el === this.gradeObservada || typeof ResizeObserver === 'undefined') return;
            if (this.observadorGrade) this.observadorGrade.disconnect();
            this.gradeObservada = el;
            this.observadorGrade = new ResizeObserver(([entrada]) => {
                const largura = entrada.contentRect.width;
                if (largura === this.larguraGrade) return;
                this.larguraGrade = largura;
                cancelAnimationFrame(this.quadroGrade);
                this.quadroGrade = requestAnimationFrame(() => {
                    const gap = 12;
                    const colunas = Math.max(1, Math.floor((largura + gap) / (200 + gap)));
                    if (colunas !== this.colunasSilos) this.colunasSilos = colunas;
                });
            });
            this.observadorGrade.observe(el);
        },
        tutorialVisto() {
            try { return localStorage.getItem(CHAVE_TUTORIAL) === '1'; } catch (e) { return true; }
        },
        gerar() {
            if (this.tutorialAberto) this.fecharTutorial();
            this.$emit('gerar');
        },
        abrirTutorial() {
            this.tutorialAberto = true;
        },
        fecharTutorial() {
            this.tutorialAberto = false;
            try { localStorage.setItem(CHAVE_TUTORIAL, '1'); } catch (e) { /* sem armazenamento */ }
        },
        fmt(v, casas = 1) {
            if (v === null || v === undefined || v === '' || isNaN(Number(v))) return '—';
            return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
        },
    },
};
</script>
